import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faTimes } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-hot-toast';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const AddToRadar = ({ product }) => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [preferredPrice, setPreferredPrice] = useState(product.price || 0);
  const [email, setEmail] = useState('');

  const addToRadar = () => {
    setShowEmailInput(true);
  };

  // const handleEmailSubmit = async () => {
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //   if (emailRegex.test(email.trim().toLowerCase())) {
  //     await axios.post(`/api/user/radar`, 
  //       { productId: product._id, email: email, preferredPrice: preferredPrice, price: product.price, productLink: product.link, prices: product.prices, 
  //         currency: product.currency, productName: product.name, image: product.image, 
  //         store: product.store, source: product.source, storeLogo: product.storeLogo },
  //       { headers: { Authorization: `Bearer ${idToken}` } }
  //     );
  //     toast.success(`${product.name} added to your email notifications!`);
  //     setShowEmailInput(false);
  //     setEmail('');
  //   } else {
  //     toast.error('Please enter a valid email address.');
  //   }

  // };
  const handleEmailSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
      // Check if email is valid and preferredPrice is provided
      if (!email || !preferredPrice) {
        toast.error('Please enter a valid email and preferred price.');
        return;
      }
    // Check if the email matches the valid format
    if (emailRegex.test(email.trim().toLowerCase())) {
      try {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/user/radar`, 
          {
            productId: product._id,
            email: email,
            preferredPrice: preferredPrice,
            price: product.price,
            productLink: product.link,
            prices: product.prices,
            currency: product.currency,
            productName: product.name,
            image: product.image,
            store: product.store,
            source: product.source,
            storeLogo: product.storeLogo
          },
          // { headers: { Authorization: `Bearer ${idToken}` } }
        );
        toast.success(`${product.name} added to your email notifications!`);
        setShowEmailInput(false);
        setEmail('');
        setPreferredPrice(product.price);  // Reset preferred price after successful submission
      } catch (error) {
        toast.error('Something went wrong, please try again.');
      }
    } else {
      toast.error('Please enter a valid email address.');
    }
  };  

  const handleRangeChange = (e) => {
    e.stopPropagation();
    setPreferredPrice(e.target.value);
  };

  return (
    <div className="add-to-radar-container flex justify-center items-center w-full">
      {!showEmailInput ? (
        <div className="flex items-center justify-center w-full">
          <button
            className="w-full bg-[#FF9900] text-white py-3 rounded-xl font-semibold hover:bg-orange-500 transition duration-200 flex items-center justify-center"
            onClick={addToRadar}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faBell} className="mr-2 text-xl rtl:ml-2" />
            {isLoading ? 'Adding...' : t('productPage.addToRadar.alertForBetterPrice')}
          </button>
        </div>
      ) : (
        <div className="email-input-container bg-white p-6 rounded-2xl shadow-md flex flex-col space-y-4 w-full max-w-lg mx-auto">
          <button
            onClick={() => setShowEmailInput(false)}
            className="absolute top-2 right-2 text-theme-primary text-xl"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <div className="email-input-field text-center space-y-2">
            <label htmlFor="email" className="text-sm font-semibold text-theme-text">
              {t('productPage.addToRadar.emailFormTitle')}
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-[#FF9900] dark:text-white dark:bg-slate-600"
              placeholder={t('productPage.addToRadar.emailPlaceholder')}
            />
          </div>
          <div className="preferred-price-field text-center space-y-2">
            <label htmlFor="preferredPrice" className="text-sm font-semibold text-theme-text">
              {t('productPage.addToRadar.preferredPrice')}
            </label>
            <input
              id="preferredPrice"
              type="range"
              min="0"
              max={Math.ceil(product.prices?.discounted || 1000)} // use product price as max
              value={preferredPrice}
              onChange={handleRangeChange}
              className="range range-primary"
            />
            <span className="text-xs text-theme-text">{`SAR ${preferredPrice}`}</span>
          </div>
          <button
            onClick={handleEmailSubmit}
            className="w-full bg-[#FF9900] text-white py-3 rounded-xl font-semibold hover:bg-orange-500 transition duration-200"
            disabled={isLoading || !email}
          >
            {t('productPage.addToRadar.submit')}
          </button>
        </div>
      )}
    </div>
  );
};

export default AddToRadar;



